import React from 'react'
import './Banner.css'
import { Link } from 'react-router'
import pulover from '../Assets/pulover.jpg'
import polo from '../Assets/polo.jpg'
import ing from '../Assets/ingek.jpg'
import galleros from '../Assets/galleros.jpg'
import noipulover from '../Assets/noipulover.jpg'
import noipolo from '../Assets/noipolo.jpg'
import noigalleros from '../Assets/noigalleros.jpg'
import noikabat from '../Assets/noikabat.jpg'
import polar from '../Assets/polar.jpg'
import formaruha from '../Assets/formaruhak.jpg'
import sport from '../Assets/sport.jpg'
import noiformaruha from '../Assets/noiformaruhak.jpg'
import noisport from '../Assets/noisport.jpg'
import noiing from '../Assets/noiing.jpg'
import gyerekpolo from '../Assets/gyerekpolo.jpg'
import gyerekgalleros from '../Assets/gyerekgalleros.jpg'
import gyerekkabat from '../Assets/gyerekkabat.jpeg'
import gyerekpulcsi from '../Assets/gyerekpulcsi.jpg'

const Banner = () => {
  return (
   <div>
        <h4 className='banner-h4'>A vásárláshoz regisztráció szükséges, kérd a csapatodtól az egyedi kuponkódod amivel még szert tehetsz +10% kedvezményre</h4>
        <h2 className="banner-h2">Férfi termékek</h2>
        <div className='banner-box'>
            <Link to='/category/Férfi/Pólók'>
                <div className='banner-element'>
                    <img src={polo} alt="" />
                    <p>PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Pulóverek'>
                <div className='banner-element'>
                    <img src={pulover} alt="" />
                    <p>PULÓVEREK</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Galléros pólók'>
                <div className='banner-element'>
                    <img src={galleros} alt="" />
                    <p>GALLÉROS PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Ing'>
                <div className='banner-element'>
                    <img src={ing} alt="" />
                    <p>INGEK</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Formaruhák'>
                <div className='banner-element'>
                    <img src={formaruha} alt="" />
                    <p>FORMARUHÁK</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Sport'>
                <div className='banner-element'>
                    <img src={sport} alt="" />
                    <p>SPORT</p>
                </div>
            </Link>
            <Link to='/category/Férfi/Polár'>
                <div className='banner-element'>
                    <img src={polar} alt="" />
                    <p>POLÁR</p>
                </div>
            </Link>
        </div>

        <h2 className="banner-h2">Női termékek</h2>
        <div className='banner-box'>
            <Link to='/category/Női/Pólók'>
                <div className='banner-element'>
                    <img src={noipolo} alt="" />
                    <p>PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Női/Pulóverek'>
                <div className='banner-element'>
                    <img src={noipulover} alt="" />
                    <p>PULÓVEREK</p>
                </div>
            </Link>
            <Link to='/category/Női/Galléros pólók'>
                <div className='banner-element'>
                    <img src={noigalleros} alt="" />
                    <p>GALLÉROS PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Női/Kabátok-Mellények'>
                <div className='banner-element'>
                    <img src={noikabat} alt="" />
                    <p>KABÁTOK</p>
                </div>
            </Link>
            <Link to='/category/Női/Ing'>
                <div className='banner-element'>
                    <img src={noiing} alt="" />
                    <p>INGEK</p>
                </div>
            </Link>
            <Link to='/category/Női/Sport'>
                <div className='banner-element'>
                    <img src={noisport} alt="" />
                    <p>SPORT</p>
                </div>
            </Link>
            <Link to='/category/Női/Formaruhák'>
                <div className='banner-element'>
                    <img src={noiformaruha} alt="" />
                    <p>FORMARUHÁK</p>
                </div>
            </Link>
        </div>

        <h2 className="banner-h2">Gyerek termékek</h2>
        <div className='banner-box'>
            <Link to='/category/Gyerek/Pólók'>
                <div className='banner-element'>
                    <img src={gyerekpolo} alt="" />
                    <p>PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Gyerek/Pulóverek'>
                <div className='banner-element'>
                    <img src={gyerekpulcsi} alt="" />
                    <p>PULÓVEREK</p>
                </div>
            </Link>
            <Link to='/category/Gyerek/Galléros pólók'>
                <div className='banner-element'>
                    <img src={gyerekgalleros} alt="" />
                    <p>GALLÉROS PÓLÓK</p>
                </div>
            </Link>
            <Link to='/category/Gyerek/Kabátok-Mellények'>
                <div className='banner-element'>
                    <img src={gyerekkabat} alt="" />
                    <p>KABÁTOK</p>
                </div>
            </Link>
            
        </div>
   </div>
  )
}

export default Banner